import { useEffect, useState } from 'react';

import { StartupPrinterBanner, StartupPrinterDialog } from './printer';
import { BrowserBanner, BrowserDialog, useBrowserApp } from './chrome-browser';

import { menuPageDialogOpened } from 'features/menu-page';
import { mozartDialogOpened } from 'features/mozart-notifications';

export function StartupNotifications() {
  const [dialogOpened, setDialogOpened] = useState({
    isOpenMozart: false,
    isOpenMenuPage: false,
  });

  const { showBanner } = useBrowserApp();
  const mozartDialog = mozartDialogOpened();
  const menuPageDialog = menuPageDialogOpened();

  useEffect(() => {
    mozartDialog.add(({ detail }) =>
      setDialogOpened(s => ({ ...s, isOpenMozart: detail })),
    );
    menuPageDialog.add(({ detail }) =>
      setDialogOpened(s => ({ ...s, isOpenMenuPage: detail })),
    );
    return () => {
      mozartDialog.remove();
      menuPageDialog.remove();
    };
  }, []);

  return (
    <>
      {!dialogOpened.isOpenMenuPage && !dialogOpened.isOpenMozart && (
        <>
          {showBanner && <BrowserBanner />}
          <StartupPrinterBanner />
        </>
      )}

      <BrowserDialog />
      <StartupPrinterDialog />
    </>
  );
}
